export const REQUEST_LOWERBOUND = 1
export const REQUEST_UPPERBOUND = 30
export const NUMBER_OF_NEXT_ITINERARIES = 40
export const MAX_ITINERARIES = 200
export const filterAdId = 'div-gpt-ad-1572965562221-0'
export const mwebFilterAdId = 'div-gpt-ad-1771612541369-0'
export const defaultSelectedTab = 1
export const SEARCH_TYPE_DEFAULT = 'AIRPORT'
export const SEARCH_DEFAULT_AIRPORT_TYPE = 'AIRPORT'
export const SEARCH_TYPE_CITY_NAME = 'CITY_NAME'
export const BUNDLE_REQUEST = 'BUNDLE_REQUEST'
export const STANDALONE_REQUEST = 'STANDALONE_REQUEST'

export const cabinClassLabels = {
  ECO: 'Economy',
  PEC: 'Premium Economy',
  BUS: 'Business',
  FST: 'First',
}

export const pclnBootstrapData = {
  appName: 'fly-retail-details',
  appVersion: 'development',
  basePath: '/m/fly/search',
  env: 'development',
  searchRequest: {
    token:
      'RS_LGA202202201745DFW202202202051GAA1806~DFW202202202240ABQ202202202330GAA2564-ABQ202202222331JFK202202230528LB666_1_USD341.20_319648361502053015-319648361502062925-1',
    params: {
      'ref-key': 'eAGrVkov8kxRslIyNrQ0M7EwNjM0NTAyMDU2MDRV0lEqSk3DlDQzsjQCSSYXg+UMlWoBOSkQAQ==',
      'num-adults': '1',
      'num-children': '0',
      'num-infants': '0',
      'itinerary-type-code': 'RT',
      'cabin-class': 'ECO',
      'search-type': 'undefined',
      type: 'rm',
      arc: 'undefined-',
      'search-key': '3196483615025',
      tripType: 'RT',
      referrals: {
        id: 'GOOGLECPC',
        sourceId: 'PL',
        clickId: 'D:cFlight16015637950g3182265460121555976393aud-381973834302:kwd-2916548846|9004393|',
        webEntryTime: '1/31/2022 16:04:48',
        expiration: '3/2/2022 16:04:48',
        trafficSource: 'PRICELINE',
        trafficTier: 1,
      },
    },
    slices: [
      {
        originAirport: 'NYC',
        destinationAirport: 'ABQ',
        travelDate: '2022-02-20',
        travelDateAsYYYYMMDD: '20220220',
        'travelDateAsmm/dd/yyyy': '02/20/2022',
      },
      {
        originAirport: 'ABQ',
        destinationAirport: 'NYC',
        travelDate: '2022-02-22',
        travelDateAsYYYYMMDD: '20220222',
        'travelDateAsmm/dd/yyyy': '02/22/2022',
      },
    ],
    slicesURL: '/NYC-ABQ-20220220/ABQ-NYC-20220222/',
    isSameDay: false,
    airports: {
      NYC: {
        airportCode: 'NYC',
        cityCode: 'NYC',
        cityName: 'New York City',
        countryCode: 'US',
        stateCode: 'NY',
        countryName: 'US',
        stateName: 'New York',
      },
      ABQ: {
        airportCode: 'ABQ',
        cityCode: 'ABQ',
        cityName: 'Albuquerque',
        countryCode: 'US',
        stateCode: 'NM',
        cityId: 1350200019,
        countryName: 'US',
        stateName: 'New Mexico',
      },
    },
  },
  appInfo: {
    appVersion: 'development',
    appName: 'unknown',
  },
  referral: {
    id: 'GOOGLECPC',
    sourceId: 'PL',
    clickId: 'D:cFlight16015637950g3182265460121555976393aud-381973834302:kwd-2916548846|9004393|',
    webEntryTime: '1/31/2022 16:04:48',
    expiration: '3/2/2022 16:04:48',
    trafficSource: 'PRICELINE',
    trafficTier: 1,
  },
  itinDetailsToken:
    'RS_LGA202202201745DFW202202202051GAA1806~DFW202202202240ABQ202202202330GAA2564-ABQ202202222331JFK202202230528LB666_1_USD341.20_319648361502053015-319648361502062925-1',
  slicesUrl: '/NYC-ABQ-20220220/ABQ-NYC-20220222/',
  params: {
    'ref-key': 'eAGrVkov8kxRslIyNrQ0M7EwNjM0NTAyMDU2MDRV0lEqSk3DlDQzsjQCSSYXg+UMlWoBOSkQAQ==',
    'num-adults': '1',
    'num-children': '0',
    'num-infants': '0',
    'itinerary-type-code': 'RT',
    'cabin-class': 'ECO',
    'search-type': 'undefined',
    type: 'rm',
    arc: 'undefined-',
    'search-key': '3196483615025',
    tripType: 'RT',
    referrals: {
      id: 'GOOGLECPC',
      sourceId: 'PL',
      clickId: 'D:cFlight16015637950g3182265460121555976393aud-381973834302:kwd-2916548846|9004393|',
      webEntryTime: '1/31/2022 16:04:48',
      expiration: '3/2/2022 16:04:48',
      trafficSource: 'PRICELINE',
      trafficTier: 1,
    },
  },
  isProd: false,
  isProductionServer: false,
  partnerBaseImageUrl: '/shop/search',
  partnerProviderAppName: 'fly-retail-details',
  partnerTrackerEnv: 'prod',
  isMobile: false,
  isDomestic: true,
  isIE: false,
  fromPackages: false,
  page: 'details',
  webstats: {
    clientGUID: '2ef4637451c052a859613ff144d1e3f3',
    resolvedClientIP: '::ffff:127.0.0.1',
    clientRequestId: '1645128062836-e-v20220204180827944fc18c-e-2ef4637451c052a859613ff144d1e3f3',
    firstTimeHere: false,
    requestId: '',
    requestTime: 1645128062836,
    startOfVisit: false,
    userAgent:
      'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/98.0.4758.80 Safari/537.36',
    visitId: 'v20220204180827944fc18c',
    isMobile: false,
  },
  derivedItinInfo: {
    flightString:
      'LGA*2022-02-20T17:45*AA*1806*DFW*2022-02-20T20:51*ECO~DFW*2022-02-20T22:40*AA*2564*ABQ*2022-02-20T23:30*ECO__ABQ*2022-02-22T23:31*B6*66*JFK*2022-02-23T05:28*BEC',
  },
  itinDetails: {
    clientSessionId: '345293b9388b68c2362cc4751edea820',
    pointOfSale: {
      requestSourceCountry: 'US',
      country: 'US',
      currency: 'USD',
    },
    imagePath: 'https://s1.pclncdn.com/design-assets/fly/carrier-logos/',
    airport: [
      {
        code: 'ABQ',
        name: 'Sunport Intl Airport',
        city: 'Albuquerque',
        state: 'NM',
        country: 'United States',
        latitude: 35.044505173,
        longitude: -106.611861222,
        isoCountryCode: 'US',
      },
      {
        code: 'DFW',
        name: 'Dallas/Fort Worth Intl Airport',
        city: 'Dallas',
        state: 'TX',
        country: 'United States',
        latitude: 32.901127357,
        longitude: -97.040372071,
        isoCountryCode: 'US',
      },
      {
        code: 'LGA',
        name: 'LaGuardia Airport',
        city: 'New York City',
        state: 'NY',
        country: 'United States',
        latitude: 40.780500251,
        longitude: -73.874771681,
        isoCountryCode: 'US',
      },
      {
        code: 'JFK',
        name: 'John F Kennedy Intl Airport',
        city: 'New York City',
        state: 'NY',
        country: 'United States',
        latitude: 40.639380747,
        longitude: -73.772040349,
        isoCountryCode: 'US',
      },
    ],
    airline: [
      {
        code: 'AA',
        name: 'American Airlines',
        baggageContentAvailable: true,
        websiteUrl: 'www.aa.com',
        smallImage: 'airLogo_AA.png',
        largeImage: 'airLogo_AAlg.gif',
        frequentFlyerProgram: 'American AAdvantage',
        phoneNumber: '1-800-433-7300',
      },
      {
        code: 'B6',
        name: 'JetBlue Airways',
        baggageContentAvailable: true,
        websiteUrl: 'www.jetblue.com/',
        smallImage: 'airLogo_B6.png',
        largeImage: 'airLogo_B6lg.gif',
        frequentFlyerProgram: 'Jet Blue TrueBlue',
        phoneNumber: '1-800-538-2583',
      },
    ],
    equipment: [
      {
        code: '320',
        name: 'Airbus A320',
        type: 'J',
      },
      {
        code: '738',
        name: 'Boeing 737-800',
        type: 'J',
      },
    ],
    alliance: [
      {
        code: 'OW',
        name: 'oneworld',
        memberCodes: [
          'JJ',
          'AA',
          'QR',
          'AB',
          'JL',
          'S7',
          'LP',
          'XL',
          'CX',
          'QF',
          'LA',
          'UL',
          'AY',
          'RJ',
          'IB',
          '4M',
          'MH',
          'BA',
        ],
      },
    ],
    referrals: [],
    elapsedTime: '222ms',
    responseTimeStamp: '2022-02-16T13:35:27',
    cabinRestrictions: {
      B6: {
        BEC: {
          bookingClass: 'L',
          cabinClass: 'BEC',
          marketingAirline: 'B6',
          upsellAvailabilityNotice:
            'Basic Economy. Carryon Bag Not Included. Seat selection available for a fee after ticket purchase',
          altUpsellNotice:
            'Basic Economy. Carryon Bag Not Included. Seat selection available for a fee after ticket purchase',
        },
      },
    },
    baggage: [
      {
        uniqueBaggageId: 1,
        airline: 'AA',
        origAirport: 'LGA',
        destAirport: 'ABQ',
      },
    ],
    slice: [
      {
        duration: 465,
        id: 1,
        segment: [
          {
            arrivalDateTime: '2022-02-20T20:51:00',
            bkgClass: 'G',
            cabinClass: 'ECO',
            cabinName: 'Economy Class',
            departDateTime: '2022-02-20T17:45:00',
            destAirport: 'DFW',
            duration: 246,
            equipmentCode: '738',
            flightNumber: '1806',
            genericSeatAssgnCost: {
              amount: 0,
              currencyCode: 'USD',
            },
            genericSeatAssgnFlag: false,
            id: 1,
            marketingAirline: 'AA',
            origAirport: 'LGA',
            overnightFlight: false,
            premiumSeatingFlag: true,
            seatmapAvailable: true,
            seatSelectionAllowed: true,
            allowStandby: true,
            allowCabinUpgrades: true,
            allowPreferredSeating: true,
            allowPriorityBoarding: true,
            stopQuantity: 0,
            distance: 1380,
            intermediateStop: [],
          },
          {
            arrivalDateTime: '2022-02-20T23:30:00',
            bkgClass: 'G',
            cabinClass: 'ECO',
            cabinName: 'Economy Class',
            departDateTime: '2022-02-20T22:40:00',
            destAirport: 'ABQ',
            duration: 110,
            equipmentCode: '738',
            flightNumber: '2564',
            genericSeatAssgnCost: {
              amount: 0,
              currencyCode: 'USD',
            },
            genericSeatAssgnFlag: false,
            id: 2,
            marketingAirline: 'AA',
            origAirport: 'DFW',
            overnightFlight: false,
            premiumSeatingFlag: true,
            seatmapAvailable: true,
            seatSelectionAllowed: true,
            allowStandby: true,
            allowCabinUpgrades: true,
            allowPreferredSeating: true,
            allowPriorityBoarding: true,
            stopQuantity: 0,
            distance: 573,
            intermediateStop: [],
          },
        ],
      },
      {
        duration: 237,
        id: 2,
        segment: [
          {
            arrivalDateTime: '2022-02-23T05:28:00',
            bkgClass: 'L',
            cabinClass: 'BEC',
            cabinName: 'Basic Economy',
            departDateTime: '2022-02-22T23:31:00',
            destAirport: 'JFK',
            duration: 237,
            equipmentCode: '320',
            flightNumber: '66',
            genericSeatAssgnFlag: false,
            id: 3,
            marketingAirline: 'B6',
            origAirport: 'ABQ',
            overnightFlight: false,
            premiumSeatingFlag: false,
            seatmapAvailable: false,
            seatSelectionAllowed: false,
            allowStandby: false,
            allowCabinUpgrades: false,
            allowPreferredSeating: false,
            allowPriorityBoarding: false,
            stopQuantity: 0,
            distance: 1811,
            intermediateStop: [],
          },
        ],
      },
    ],
    pricingInfo: {
      baseFare: 303,
      currencyCode: 'USD',
      insuranceCost: 18,
      merchantOfRecord: 'CXR',
      tax: [
        {
          amount: 21.14,
          taxCode: 'US',
        },
      ],
      totalFare: 341.2,
      totalTaxes: 38.2,
      uniqueBaggageId: [1],
      exchangeRateInfo: {
        fromCurrencyCode: 'USD',
        toCurrencyCode: 'USD',
        rate: 1,
      },
      componentItinPricingInfo: [
        {
          baseFare: 169,
          currencyCode: 'USD',
          insuranceCost: 18,
          merchantOfRecord: 'CXR',
          tax: [
            {
              amount: 11.79,
              taxCode: 'US',
            },
          ],
          ticketingAirline: 'AA',
          ticketType: 'E',
          totalFare: 192.6,
          totalTaxes: 23.6,
          uniqueBaggageId: [1],
          exchangeRateInfo: {
            fromCurrencyCode: 'USD',
            toCurrencyCode: 'USD',
            rate: 1,
          },
          sliceId: 1,
          fareFamilyRequest: false,
          pricesByType: {
            1: {
              currencyCode: 'USD',
              baseFare: 169,
              totalTaxes: 23.6,
              fees: [
                {
                  amount: 0,
                  feeCode: 'OFFER',
                },
              ],
              totalFare: 192.6,
            },
          },
          paxTypePrices: {
            ADT: {
              pointOfSale: 1,
              transaction: 1,
              display: 1,
            },
          },
          travelInsurance: [
            {
              cost: 18,
              countryCode: 'US',
            },
            {
              cost: 18,
              countryCode: 'CA',
            },
          ],
          fees: [
            {
              amount: 0,
              feeCode: 'OFFER',
            },
          ],
        },
        {
          baseFare: 134,
          currencyCode: 'USD',
          insuranceCost: 18,
          merchantOfRecord: 'CXR',
          tax: [
            {
              amount: 9.35,
              taxCode: 'US',
            },
          ],
          ticketingAirline: 'B6',
          ticketType: 'E',
          totalFare: 148.6,
          totalTaxes: 14.6,
          uniqueBaggageId: [2],
          exchangeRateInfo: {
            fromCurrencyCode: 'USD',
            toCurrencyCode: 'USD',
            rate: 1,
          },
          sliceId: 2,
          fareFamilyRequest: false,
          pricesByType: {
            1: {
              currencyCode: 'USD',
              baseFare: 134,
              totalTaxes: 14.6,
              fees: [
                {
                  amount: 0,
                  feeCode: 'OFFER',
                },
              ],
              totalFare: 148.6,
            },
          },
          paxTypePrices: {
            ADT: {
              pointOfSale: 1,
              transaction: 1,
              display: 1,
            },
          },
          travelInsurance: [
            {
              cost: 18,
              countryCode: 'US',
            },
            {
              cost: 18,
              countryCode: 'CA',
            },
          ],
          fees: [
            {
              amount: 0,
              feeCode: 'OFFER',
            },
          ],
        },
      ],
      fareFamilyRequest: false,
      pricesByType: {
        1: {
          currencyCode: 'USD',
          baseFare: 303,
          totalTaxes: 38.2,
          fees: [
            {
              amount: 0,
              feeCode: 'OFFER',
            },
          ],
          totalFare: 341.2,
        },
      },
      paxTypePrices: {
        ADT: {
          pointOfSale: 1,
          transaction: 1,
          display: 1,
        },
      },
      travelInsurance: [
        {
          cost: 18,
          countryCode: 'US',
        },
        {
          cost: 18,
          countryCode: 'CA',
        },
      ],
      fees: [
        {
          amount: 0,
          feeCode: 'OFFER',
        },
      ],
    },
    changesAllowed: false,
    lapInfantsAllowed: true,
    passportRequired: false,
    nationalityRequired: false,
    paxMinimumAge: 16,
    numberInParty: 1,
    totalTripDurationInHours: 59,
    baggageURL: 'https://www.priceline.com/help/#/faq/ext(air_phone_list)',
    itineraryType: 'ROUND_TRIP',
    isInterline: true,
    numSeats: 1,
    isFareFamily: true,
    isSaleEligible: false,
    cugEligible: false,
    saleSavingsAmt: {
      currency: 'USD',
      amount: 0,
    },
    mealTypes: [],
    frequentFlyerPrograms: [],
    componentInformationList: [
      {
        voidWindowClose: '2022-02-17T23:29:00',
        baggageURL: 'https://www.priceline.com/help#/faq/ext(baggage_fee_AA)',
        sliceId: 1,
        voidWindowCloseTZDesignator: '-0500',
      },
      {
        voidWindowClose: '2022-02-17T23:29:00',
        baggageURL: 'https://www.priceline.com/help#/faq/ext(baggage_fee_B6)',
        sliceId: 2,
        voidWindowCloseTZDesignator: '-0500',
      },
    ],
    lengthOfStayHours: 59,
    pricelineBaggageFeeURL: 'https://www.priceline.com/help/#/faq/ext(air_phone_list)',
    pricingInfoList: [
      {
        baseFare: 303,
        currencyCode: 'USD',
        insuranceCost: 18,
        merchantOfRecord: 'CXR',
        tax: [
          {
            amount: 21.14,
            taxCode: 'US',
          },
        ],
        totalFare: 341.2,
        totalTaxes: 38.2,
        uniqueBaggageId: [1],
        exchangeRateInfo: {
          fromCurrencyCode: 'USD',
          toCurrencyCode: 'USD',
          rate: 1,
        },
        componentItinPricingInfo: [
          {
            baseFare: 169,
            currencyCode: 'USD',
            insuranceCost: 18,
            merchantOfRecord: 'CXR',
            tax: [
              {
                amount: 11.79,
                taxCode: 'US',
              },
            ],
            ticketingAirline: 'AA',
            ticketType: 'E',
            totalFare: 192.6,
            totalTaxes: 23.6,
            uniqueBaggageId: [1],
            exchangeRateInfo: {
              fromCurrencyCode: 'USD',
              toCurrencyCode: 'USD',
              rate: 1,
            },
            sliceId: 1,
            fareFamilyRequest: false,
            pricesByType: {
              1: {
                currencyCode: 'USD',
                baseFare: 169,
                totalTaxes: 23.6,
                fees: [
                  {
                    amount: 0,
                    feeCode: 'OFFER',
                  },
                ],
                totalFare: 192.6,
              },
            },
            paxTypePrices: {
              ADT: {
                pointOfSale: 1,
                transaction: 1,
                display: 1,
              },
            },
            travelInsurance: [
              {
                cost: 18,
                countryCode: 'US',
              },
              {
                cost: 18,
                countryCode: 'CA',
              },
            ],
            fees: [
              {
                amount: 0,
                feeCode: 'OFFER',
              },
            ],
          },
          {
            baseFare: 134,
            currencyCode: 'USD',
            insuranceCost: 18,
            merchantOfRecord: 'CXR',
            tax: [
              {
                amount: 9.35,
                taxCode: 'US',
              },
            ],
            ticketingAirline: 'B6',
            ticketType: 'E',
            totalFare: 148.6,
            totalTaxes: 14.6,
            uniqueBaggageId: [2],
            exchangeRateInfo: {
              fromCurrencyCode: 'USD',
              toCurrencyCode: 'USD',
              rate: 1,
            },
            sliceId: 2,
            fareFamilyRequest: false,
            pricesByType: {
              1: {
                currencyCode: 'USD',
                baseFare: 134,
                totalTaxes: 14.6,
                fees: [
                  {
                    amount: 0,
                    feeCode: 'OFFER',
                  },
                ],
                totalFare: 148.6,
              },
            },
            paxTypePrices: {
              ADT: {
                pointOfSale: 1,
                transaction: 1,
                display: 1,
              },
            },
            travelInsurance: [
              {
                cost: 18,
                countryCode: 'US',
              },
              {
                cost: 18,
                countryCode: 'CA',
              },
            ],
            fees: [
              {
                amount: 0,
                feeCode: 'OFFER',
              },
            ],
          },
        ],
        fareFamilyRequest: false,
        pricesByType: {
          1: {
            currencyCode: 'USD',
            baseFare: 303,
            totalTaxes: 38.2,
            fees: [
              {
                amount: 0,
                feeCode: 'OFFER',
              },
            ],
            totalFare: 341.2,
          },
        },
        paxTypePrices: {
          ADT: {
            pointOfSale: 1,
            transaction: 1,
            display: 1,
          },
        },
        travelInsurance: [
          {
            cost: 18,
            countryCode: 'US',
          },
          {
            cost: 18,
            countryCode: 'CA',
          },
        ],
        fees: [
          {
            amount: 0,
            feeCode: 'OFFER',
          },
        ],
      },
    ],
    itineraryReference: {
      refKey: 'eAGrVkov8kxRslIyNrQ0M7EwNjM0NTAyMDU2MDRV0lEqSk3DlDQzsjQCSSYXg+UMlWoBOSkQAQ==',
    },
  },
}

export const itineraryDetails = {
  clientSessionId: '2098d5680c8a92c094ced371ecc73ce9',
  pointOfSale: {
    requestSourceCountry: 'US',
    country: 'US',
    currency: 'USD',
  },
  imagePath: 'https://s1.pclncdn.com/design-assets/fly/carrier-logos/',
  airport: [
    {
      code: 'ABQ',
      name: 'Sunport Intl Airport',
      city: 'Albuquerque',
      state: 'NM',
      country: 'United States',
      latitude: 35.044505173,
      longitude: -106.611861222,
      isoCountryCode: 'US',
    },
    {
      code: 'IAH',
      name: 'George Bush Intercontinental Airport',
      city: 'Houston',
      state: 'TX',
      country: 'United States',
      latitude: 29.986720236,
      longitude: -95.342239758,
      isoCountryCode: 'US',
    },
    {
      code: 'EWR',
      name: 'Newark Liberty Intl Airport',
      city: 'Newark',
      state: 'NJ',
      country: 'United States',
      latitude: 40.690545878,
      longitude: -74.16978765,
      isoCountryCode: 'US',
    },
    {
      code: 'JFK',
      name: 'John F Kennedy Intl Airport',
      city: 'New York City',
      state: 'NY',
      country: 'United States',
      latitude: 40.639380747,
      longitude: -73.772040349,
      isoCountryCode: 'US',
    },
  ],
  airline: [
    {
      code: 'B6',
      name: 'JetBlue Airways',
      baggageContentAvailable: true,
      websiteUrl: 'www.jetblue.com/',
      smallImage: 'airLogo_B6.png',
      largeImage: 'airLogo_B6lg.gif',
      frequentFlyerProgram: 'Jet Blue TrueBlue',
      phoneNumber: '1-800-538-2583',
    },
    {
      code: 'UA',
      name: 'United Airlines',
      baggageContentAvailable: true,
      websiteUrl: 'www.united.com/en/us/',
      smallImage: 'airLogo_UA.png',
      largeImage: 'airLogo_UAlg.gif',
      frequentFlyerProgram: 'United MileagePlus',
      phoneNumber: '1-800-864-8331',
    },
  ],
  equipment: [
    {
      code: '320',
      name: 'Airbus A320',
      type: 'J',
    },
    {
      code: '738',
      name: 'Boeing 737-800',
      type: 'J',
    },
  ],
  alliance: [
    {
      code: 'SA',
      name: 'Star Alliance',
      memberCodes: [
        'LO',
        'JP',
        'LX',
        'UA',
        'NZ',
        'SA',
        'BR',
        'A3',
        'SK',
        'SN',
        'CA',
        'SQ',
        'AC',
        'OS',
        'MS',
        'OU',
        'AI',
        'CM',
        'OZ',
        'ZH',
        'ET',
        'TG',
        'AV',
        'TK',
        'NH',
        'LH',
        'TP',
      ],
    },
  ],
  referrals: [],
  elapsedTime: '213ms',
  responseTimeStamp: '2022-02-17T15:00:58',
  cabinRestrictions: {
    B6: {
      BEC: {
        bookingClass: 'L',
        cabinClass: 'BEC',
        marketingAirline: 'B6',
        upsellAvailabilityNotice:
          'Basic Economy. Carryon Bag Not Included. Seat selection available for a fee after ticket purchase',
        altUpsellNotice:
          'Basic Economy. Carryon Bag Not Included. Seat selection available for a fee after ticket purchase',
      },
    },
  },
  baggage: [
    {
      uniqueBaggageId: 1,
      airline: 'UA',
      origAirport: 'EWR',
      destAirport: 'ABQ',
    },
  ],
  slice: [
    {
      duration: 551,
      id: 1,
      segment: [
        {
          arrivalDateTime: '2022-02-20T15:40:00',
          bkgClass: 'S',
          cabinClass: 'ECO',
          cabinName: 'Economy Class',
          departDateTime: '2022-02-20T12:40:00',
          destAirport: 'IAH',
          duration: 240,
          equipmentCode: '738',
          flightNumber: '669',
          genericSeatAssgnCost: {
            amount: 0,
            currencyCode: 'USD',
          },
          genericSeatAssgnFlag: false,
          id: 1,
          marketingAirline: 'UA',
          origAirport: 'EWR',
          overnightFlight: false,
          premiumSeatingFlag: false,
          seatmapAvailable: true,
          seatSelectionAllowed: true,
          allowStandby: true,
          allowCabinUpgrades: true,
          allowPreferredSeating: true,
          allowPriorityBoarding: true,
          stopQuantity: 0,
          distance: 1419,
          intermediateStop: [],
        },
        {
          arrivalDateTime: '2022-02-20T19:51:00',
          bkgClass: 'S',
          cabinClass: 'ECO',
          cabinName: 'Economy Class',
          departDateTime: '2022-02-20T18:30:00',
          destAirport: 'ABQ',
          duration: 141,
          equipmentCode: '738',
          flightNumber: '1050',
          genericSeatAssgnCost: {
            amount: 0,
            currencyCode: 'USD',
          },
          genericSeatAssgnFlag: false,
          id: 2,
          marketingAirline: 'UA',
          origAirport: 'IAH',
          overnightFlight: false,
          premiumSeatingFlag: false,
          seatmapAvailable: true,
          seatSelectionAllowed: true,
          allowStandby: true,
          allowCabinUpgrades: true,
          allowPreferredSeating: true,
          allowPriorityBoarding: true,
          stopQuantity: 0,
          distance: 751,
          intermediateStop: [],
        },
      ],
    },
    {
      duration: 237,
      id: 2,
      segment: [
        {
          arrivalDateTime: '2022-02-23T05:28:00',
          bkgClass: 'L',
          cabinClass: 'BEC',
          cabinName: 'Basic Economy',
          departDateTime: '2022-02-22T23:31:00',
          destAirport: 'JFK',
          duration: 237,
          equipmentCode: '320',
          flightNumber: '66',
          genericSeatAssgnFlag: false,
          id: 3,
          marketingAirline: 'B6',
          origAirport: 'ABQ',
          overnightFlight: false,
          premiumSeatingFlag: false,
          seatmapAvailable: false,
          seatSelectionAllowed: false,
          allowStandby: false,
          allowCabinUpgrades: false,
          allowPreferredSeating: false,
          allowPriorityBoarding: false,
          stopQuantity: 0,
          distance: 1811,
          intermediateStop: [],
        },
      ],
    },
  ],
  pricingInfo: {
    baseFare: 339,
    currencyCode: 'USD',
    insuranceCost: 18,
    merchantOfRecord: 'CXR',
    tax: [
      {
        amount: 23.65,
        taxCode: 'US',
      },
    ],
    totalFare: 377.2,
    totalTaxes: 38.2,
    uniqueBaggageId: [1],
    exchangeRateInfo: {
      fromCurrencyCode: 'USD',
      toCurrencyCode: 'USD',
      rate: 1,
    },
    componentItinPricingInfo: [
      {
        baseFare: 205,
        currencyCode: 'USD',
        insuranceCost: 18,
        merchantOfRecord: 'CXR',
        tax: [
          {
            amount: 14.3,
            taxCode: 'US',
          },
        ],
        ticketingAirline: 'UA',
        ticketType: 'E',
        totalFare: 228.6,
        totalTaxes: 23.6,
        uniqueBaggageId: [1],
        exchangeRateInfo: {
          fromCurrencyCode: 'USD',
          toCurrencyCode: 'USD',
          rate: 1,
        },
        sliceId: 1,
        fareFamilyRequest: false,
        pricesByType: {
          1: {
            currencyCode: 'USD',
            baseFare: 205,
            totalTaxes: 23.6,
            fees: [
              {
                amount: 0,
                feeCode: 'OFFER',
              },
            ],
            totalFare: 228.6,
          },
        },
        paxTypePrices: {
          ADT: {
            pointOfSale: 1,
            transaction: 1,
            display: 1,
          },
        },
        travelInsurance: [
          {
            cost: 18,
            countryCode: 'US',
          },
          {
            cost: 18,
            countryCode: 'CA',
          },
        ],
        fees: [
          {
            amount: 0,
            feeCode: 'OFFER',
          },
        ],
      },
      {
        baseFare: 134,
        currencyCode: 'USD',
        insuranceCost: 18,
        merchantOfRecord: 'CXR',
        tax: [
          {
            amount: 9.35,
            taxCode: 'US',
          },
        ],
        ticketingAirline: 'B6',
        ticketType: 'E',
        totalFare: 148.6,
        totalTaxes: 14.6,
        uniqueBaggageId: [2],
        exchangeRateInfo: {
          fromCurrencyCode: 'USD',
          toCurrencyCode: 'USD',
          rate: 1,
        },
        sliceId: 2,
        fareFamilyRequest: false,
        pricesByType: {
          1: {
            currencyCode: 'USD',
            baseFare: 134,
            totalTaxes: 14.6,
            fees: [
              {
                amount: 0,
                feeCode: 'OFFER',
              },
            ],
            totalFare: 148.6,
          },
        },
        paxTypePrices: {
          ADT: {
            pointOfSale: 1,
            transaction: 1,
            display: 1,
          },
        },
        travelInsurance: [
          {
            cost: 18,
            countryCode: 'US',
          },
          {
            cost: 18,
            countryCode: 'CA',
          },
        ],
        fees: [
          {
            amount: 0,
            feeCode: 'OFFER',
          },
        ],
      },
    ],
    fareFamilyRequest: false,
    pricesByType: {
      1: {
        currencyCode: 'USD',
        baseFare: 339,
        totalTaxes: 38.2,
        fees: [
          {
            amount: 0,
            feeCode: 'OFFER',
          },
        ],
        totalFare: 377.2,
      },
    },
    paxTypePrices: {
      ADT: {
        pointOfSale: 1,
        transaction: 1,
        display: 1,
      },
    },
    travelInsurance: [
      {
        cost: 18,
        countryCode: 'US',
      },
      {
        cost: 18,
        countryCode: 'CA',
      },
    ],
    fees: [
      {
        amount: 0,
        feeCode: 'OFFER',
      },
    ],
  },
  changesAllowed: false,
  lapInfantsAllowed: true,
  passportRequired: false,
  nationalityRequired: false,
  paxMinimumAge: 16,
  numberInParty: 1,
  totalTripDurationInHours: 64,
  baggageURL: 'https://www.priceline.com/help/#/faq/ext(air_phone_list)',
  itineraryType: 'ROUND_TRIP',
  isInterline: true,
  numSeats: 1,
  isFareFamily: true,
  isSaleEligible: false,
  cugEligible: false,
  saleSavingsAmt: {
    currency: 'USD',
    amount: 0,
  },
  mealTypes: [],
  frequentFlyerPrograms: [],
  componentInformationList: [
    {
      voidWindowClose: '2022-02-18T23:29:00',
      baggageURL: 'https://www.priceline.com/help#/faq/ext(baggage_fee_UA)',
      sliceId: 1,
      voidWindowCloseTZDesignator: '-0500',
    },
    {
      voidWindowClose: '2022-02-18T23:29:00',
      baggageURL: 'https://www.priceline.com/help#/faq/ext(baggage_fee_B6)',
      sliceId: 2,
      voidWindowCloseTZDesignator: '-0500',
    },
  ],
  lengthOfStayHours: 64,
  pricelineBaggageFeeURL: 'https://www.priceline.com/help/#/faq/ext(air_phone_list)',
  pricingInfoList: [
    {
      baseFare: 339,
      currencyCode: 'USD',
      insuranceCost: 18,
      merchantOfRecord: 'CXR',
      tax: [
        {
          amount: 23.65,
          taxCode: 'US',
        },
      ],
      totalFare: 377.2,
      totalTaxes: 38.2,
      uniqueBaggageId: [1],
      exchangeRateInfo: {
        fromCurrencyCode: 'USD',
        toCurrencyCode: 'USD',
        rate: 1,
      },
      componentItinPricingInfo: [
        {
          baseFare: 205,
          currencyCode: 'USD',
          insuranceCost: 18,
          merchantOfRecord: 'CXR',
          tax: [
            {
              amount: 14.3,
              taxCode: 'US',
            },
          ],
          ticketingAirline: 'UA',
          ticketType: 'E',
          totalFare: 228.6,
          totalTaxes: 23.6,
          uniqueBaggageId: [1],
          exchangeRateInfo: {
            fromCurrencyCode: 'USD',
            toCurrencyCode: 'USD',
            rate: 1,
          },
          sliceId: 1,
          fareFamilyRequest: false,
          pricesByType: {
            1: {
              currencyCode: 'USD',
              baseFare: 205,
              totalTaxes: 23.6,
              fees: [
                {
                  amount: 0,
                  feeCode: 'OFFER',
                },
              ],
              totalFare: 228.6,
            },
          },
          paxTypePrices: {
            ADT: {
              pointOfSale: 1,
              transaction: 1,
              display: 1,
            },
          },
          travelInsurance: [
            {
              cost: 18,
              countryCode: 'US',
            },
            {
              cost: 18,
              countryCode: 'CA',
            },
          ],
          fees: [
            {
              amount: 0,
              feeCode: 'OFFER',
            },
          ],
        },
        {
          baseFare: 134,
          currencyCode: 'USD',
          insuranceCost: 18,
          merchantOfRecord: 'CXR',
          tax: [
            {
              amount: 9.35,
              taxCode: 'US',
            },
          ],
          ticketingAirline: 'B6',
          ticketType: 'E',
          totalFare: 148.6,
          totalTaxes: 14.6,
          uniqueBaggageId: [2],
          exchangeRateInfo: {
            fromCurrencyCode: 'USD',
            toCurrencyCode: 'USD',
            rate: 1,
          },
          sliceId: 2,
          fareFamilyRequest: false,
          pricesByType: {
            1: {
              currencyCode: 'USD',
              baseFare: 134,
              totalTaxes: 14.6,
              fees: [
                {
                  amount: 0,
                  feeCode: 'OFFER',
                },
              ],
              totalFare: 148.6,
            },
          },
          paxTypePrices: {
            ADT: {
              pointOfSale: 1,
              transaction: 1,
              display: 1,
            },
          },
          travelInsurance: [
            {
              cost: 18,
              countryCode: 'US',
            },
            {
              cost: 18,
              countryCode: 'CA',
            },
          ],
          fees: [
            {
              amount: 0,
              feeCode: 'OFFER',
            },
          ],
        },
      ],
      fareFamilyRequest: false,
      pricesByType: {
        1: {
          currencyCode: 'USD',
          baseFare: 339,
          totalTaxes: 38.2,
          fees: [
            {
              amount: 0,
              feeCode: 'OFFER',
            },
          ],
          totalFare: 377.2,
        },
      },
      paxTypePrices: {
        ADT: {
          pointOfSale: 1,
          transaction: 1,
          display: 1,
        },
      },
      travelInsurance: [
        {
          cost: 18,
          countryCode: 'US',
        },
        {
          cost: 18,
          countryCode: 'CA',
        },
      ],
      fees: [
        {
          amount: 0,
          feeCode: 'OFFER',
        },
      ],
    },
  ],
  itineraryReference: {
    refKey: 'eAGrVkov8kxRslIyNjIwtzAzMjQyMTMyMDQ2MjFV0lEqSk3DImlubAGSTC4Gyxkq1QIAN2UP+A==',
  },
  showSale: false,
  saleStyles: {
    badgeForegroundColor: '#fff',
    badgeBackgroundColor: '#0a0',
    badgeText: 'FLIGHT SALE',
    copyForegroundColor: '#0a0',
    copyText: 'Save $price',
  },
}

export const phoneSalesQueryInput = {
  requestId: '1645128062836-e-v20220204180827944fc18c-e-2ef4637451c052a859613ff144d1e3f3',
  cguid: '2ef4637451c052a859613ff144d1e3f3',
  refid: 'PLGOOGLECPC',
  clientDevice: 'DESKTOP',
  isTestNumber: false,
  advancedPurchaseWindow: 3,
  currencyCode: 'USD',
  origCountryCode: 'US',
  destCountryCode: 'US',
  originAirport: 'NYC',
  destinationAirport: 'ABQ',
  isInternational: true,
  passengers: 1,
  travelStartDate: '2022-02-20',
  travelEndDate: '2022-02-22',
  searchOptions: {
    cabinClass: 'ECO',
  },
  pageType: 'DETAILS',
  tripType: 'RT',
  marketingAirline: [],
  operatingAirline: ['UA', 'UA', 'B6'],
  lengthOfStay: 2,
}
